import { useEffect, useState } from "react";
import api from "@/lib/api";

const stats = [
  { key: "products", label: "Total Products" },
  { key: "products_in_stock", label: "In Stock" },
  { key: "orders", label: "Total Orders" },
  { key: "pending_orders", label: "Pending Orders" },
  { key: "class_registrations", label: "Class Regs" },
  { key: "subscription_signups", label: "Sub Signups" },
  { key: "event_bookings", label: "Event Bookings" },
  { key: "messages", label: "Messages" },
];

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setData(r.data)); }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl text-[color:var(--color-primary)] mb-2">Dashboard</h1>
      <p className="text-sm text-gray-500 mb-8">Overview of recent activity.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        {stats.map((s) => (
          <div key={s.key} className="bg-white border border-[color:var(--color-border)] rounded p-5" data-testid={`stat-${s.key}`}>
            <div className="text-xs uppercase tracking-widest text-gray-500">{s.label}</div>
            <div className="font-display text-3xl text-[color:var(--color-primary)] mt-2">{data?.counts?.[s.key] ?? "—"}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-[color:var(--color-border)] rounded p-5">
          <h3 className="font-display text-xl mb-4">Recent Orders</h3>
          <ul className="divide-y divide-[color:var(--color-border)]">
            {(data?.recent_orders || []).map(o => (
              <li key={o.id} className="py-3 text-sm" data-testid={`recent-order-${o.id}`}>
                <div className="flex justify-between">
                  <div><b>{o.product_name}</b> · {o.customer_name}</div>
                  <div className="text-gray-500">{o.status}</div>
                </div>
                <div className="text-xs text-gray-500">£{o.price?.toFixed(2)} · {(o.created_at||"").split("T")[0]}</div>
              </li>
            ))}
            {(!data?.recent_orders || data.recent_orders.length === 0) && (
              <li className="py-6 text-sm text-gray-500">No orders yet.</li>
            )}
          </ul>
        </div>
        <div className="bg-white border border-[color:var(--color-border)] rounded p-5">
          <h3 className="font-display text-xl mb-4">Recent Messages</h3>
          <ul className="divide-y divide-[color:var(--color-border)]">
            {(data?.recent_messages || []).map(m => (
              <li key={m.id} className="py-3 text-sm" data-testid={`recent-msg-${m.id}`}>
                <div className="font-medium">{m.name} <span className="text-xs text-gray-500">· {m.email}</span></div>
                <div className="text-gray-600 line-clamp-2">{m.message}</div>
              </li>
            ))}
            {(!data?.recent_messages || data.recent_messages.length === 0) && (
              <li className="py-6 text-sm text-gray-500">No messages yet.</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
